import AARPAuthService       from '../AARPAuthService';
import { isServer }          from '../../../utils';


export enum FriendTabs { 
    OrderByDate = 'date', 
    OrderByFriend = 'friend', 
    OrderByDateAll = 'dateAll', 
    OrderByFriendAll = 'friendAll',
    GlobalFriend = 'global', 
    Invite = 'invte',
    ViewSendChallenges = 'sendChallenges',
    ViewReceivedChallenges = 'receivedChallenges',
    ViewChallengeByDate = 'gameDateSendChallenge',
    ViewReceivedChallengeByDate = 'gameDateReceivedChallenge'
}

class FriendService {
    public friendGuid ='frGuid';
    public acceptGuid ='acGuid';
        
    public redirectToLogin() {
        const returnUrl = new URL(window.location.href);
        const url = AARPAuthService.buildBaseAuthLink(returnUrl.href);
        window.location.replace(url.href);
    }

    public redirectToLoginAndAcceptFriend() {

        const guid = this.getInvitationGuidFromUrl(this.friendGuid);
        const returnUrl = new URL(window.location.href);
        returnUrl.searchParams.delete(this.friendGuid);
        returnUrl.searchParams.set(this.acceptGuid, guid);

        const url = AARPAuthService.buildBaseAuthLink(returnUrl.href);
        window.location.replace(url.href);
    }

    public getLinkToInvite(guid:string): string
    {
        if (!isServer) {
            const url = new URL(window.location.href);
            url.searchParams.delete(this.acceptGuid);
            url.searchParams.set(this.friendGuid, guid);
            return url.href;
        }
        return null;
    }

    public getInvitationGuidFromUrl(param:string)
    {
        if (!isServer) {
            const url = new URL((window as any).location.href);
            return url.searchParams.get(param);
        }
        return null;
    }

    public getAtlterTab(activeTab: FriendTabs): FriendTabs {
        switch (activeTab) {
            case FriendTabs.OrderByDate:
                return FriendTabs.OrderByDateAll;
                
            case FriendTabs.OrderByDateAll:
                return FriendTabs.OrderByDate;
                
            case FriendTabs.OrderByFriend:
                return FriendTabs.OrderByFriendAll;
                
            case FriendTabs.OrderByFriendAll:
                return FriendTabs.OrderByFriend;
            
            case FriendTabs.ViewSendChallenges:
                return FriendTabs.ViewReceivedChallenges;
        
            case FriendTabs.ViewReceivedChallenges:
                return FriendTabs.ViewSendChallenges;
            
            default:
                return null;
        }
    }
}
    
export default new FriendService();
